import { useMemo } from 'react'
import { isNotEmpty, type AuditProps, type AuditLog } from '@terros/common'

type AuditData = Pick<AuditProps, 'modifiedBy' | 'createdAt' | 'createdBy' | 'updatedAt' | 'updatedBy'>

export const useSortedModifications = ({
  modifiedBy,
  createdAt,
  createdBy,
  updatedAt,
  updatedBy,
}: AuditData): AuditLog[] => {
  return useMemo(() => {
    if (isNotEmpty(modifiedBy)) {
      return [...modifiedBy].sort((a, b) => b.timestamp - a.timestamp)
    }
    const modifications = []
    if (createdAt && createdBy) {
      modifications.push({
        timestamp: createdAt,
        userId: createdBy,
      })
    }
    if (updatedAt && updatedBy) {
      modifications.push({
        timestamp: updatedAt,
        userId: updatedBy,
      })
    }
    return modifications.sort((a, b) => b.timestamp - a.timestamp)
  }, [modifiedBy, createdAt, createdBy, updatedAt, updatedBy])
}
